import { useState } from 'react';
import RecipeFiltersModal from './RecipeFiltersModal';
import RecipeFiltersIcon from './RecipeFiltersIcon';

export default function RecipeFiltersMobile(props) {
	const [showModal, setShowModal] = useState(false);

	const showRecipeFiltersModal = () => {
		setShowModal(!showModal);
	};

	return (
		<div className="recipe-filters-mobile">
			{ !showModal && (
				<button
					type="button"
					className="recipe-filters-mobile-button"
					onClick={() => { showRecipeFiltersModal(); }}
				>
					<span className="recipe-filters-mobile-button-label">Add Filters</span>
					<RecipeFiltersIcon className="recipe-filters-mobile-button-icon" />
				</button>
			)}
			<RecipeFiltersModal
				showModal={showModal}
				closeModal={showRecipeFiltersModal}
				{...props}
			/>
		</div>
	);
}
